module.exports = __webpack_public_path__ + "static/media/YB5M17_2.e69242dd.jpg";